import React from 'react';
import { Link } from 'react-router-dom';

import { IMainNews } from '../../types/mainNews';
import { NewsItem } from './components/NewsItem';
import * as s from './MainNews.css';

/** Блок новостей на Главной */
export const MainNews = ({ items }: IMainNews) => {
  return (
    <div className={s['wrapper']} data-web-ui-test-id="MainNews">
      <div className={s['header-link-wrapper']}>
        <Link to={`/novosti/`} className={s['header-link']}>
          Новости
        </Link>

        <div className={s['separator']} />
      </div>

      <div className={s['items-wrapper']}>
        {items.map(item => (
          <NewsItem key={`news-${item.id}`} {...item} />
        ))}
      </div>

      <div className={s['more-link-wrapper']}>
        <div className={s['gradient']} />

        <Link to={`/novosti/`} className={s['more-link']}>
          Все новости
        </Link>
      </div>
    </div>
  );
};
